<template>
	<div class="page">
		<div class="pub_nav" :class="showBg ? 'nav_bg' : ''">
			<div class="status_bar"></div>
			<div class="nav_box">
				收到乐
				<div class="search_box" @click="goShops()">
					<input type="text" class="ipt" placeholder-class="placeColor" placeholder="  请输入商家名称" />
					<img src="../assets/img/pro_i02_blue.png" class="icon"></img>
				</div>
			</div>
		</div>
		<div class="idx_main">
			<div class="idx_main_top">
				<img src="../assets/img/idx_bg_blue.png" class="img top_img"></img>
				<div class="swiper_box">
					<div class="hot_box" @click="goShops()">
						<div class="tit">热搜:</div>
						<div class="hot">美食/养生</div>
						<div class="hot">母婴/丽人</div>
						<div class="hot">美发/健身</div>
						<!-- <div class="hot">超市/购物</div> -->
					</div>
					<div class="swier-bg-box">
						<van-swipe :autoplay="3000" class="swier-item" indicator-color="#00BFFF">
							<van-swipe-item style="padding: 0;" v-for="(item, index) in dataList.bannerslist" :key="index"
								@click="bannerJump(item)">
								<div class="swiper-item">
									<img :src="item.img_url" class="img" />
								</div>
							</van-swipe-item>
						</van-swipe>
					</div>
					<!-- <swiper :indicator-dots="indicatorDots" :autoplay="autoplay" :interval="interval"
						:duration="duration">
						<swiper-item v-for="(item, index) in datas.bannerslist">
							<div class="swiper-item">
								<img :src="item.img_url" class="img" mode="aspectFill"></img>
							</div>
						</swiper-item>
					</swiper> -->
				</div>
				<div class="menus">
					<a v-for="(item, index) in datas.iconList" hover-class="none" class="menu"
						@click="handleGoIcon(item)">
						<img :src="item.img_url" class="icon"></img>
						<div class="tit">{{ item.title }}</div>
					</a>
				</div>
			</div>
			<div class="active_box">
				<div class="active_box_c">
					<div class="li" @click="handleGoNows(datas.notice.id)">
						<img src="../assets/img/idx_i12_blue.png" class="icon"></img>
						<div class="title ellipsis1">{{ datas.notice.title }}</div>
						<img src="../assets/img/idx_arr.png" class="arr"></img>
					</div>
				</div>
			</div>
			<!-- 限时抢购 -->
			<div class="modal idx-store" v-if="dataList.home_xianshi_img.img_url!=null">
				<div class="modal_top">
					<div class="title_box">
						<div class="title_box_l">
							<img src="../assets/img/idx_i15_blue.png" class="icon"></img>
							<div class="title">
								<div class="gl">限时</div>
								抢购
							</div>
						</div>
						<div class="title_box_r" @click="goXs()">
							查看全部
							<img src="../assets/img/idx_arr.png" class="arr"></img>
						</div>
					</div>
				</div>
				<div class="list">
					<img @click="goXs()" :src="dataList.home_xianshi_img.img_url" class="my-ad"></img>
				</div>
			</div>
			<div class="modal idx-store">
				<div class="modal_top">
					<div class="title_box">
						<div class="title_box_l">
							<img src="../assets/img/idx_i13_blue.png" class="icon"></img>
							<div class="title">
								<div class="gl">附近</div>
								商家活动
							</div>
						</div>
						<div class="title_box_r" @click="goShops()">
							查看全部
							<img src="../assets/img/idx_arr.png" class="arr"></img>
						</div>
					</div>
					<div class="types">
						<div v-for="(item, index) in shopcates" class="type"
							:class="typeCur == shopids[index] ? 'cur' : ''" @click="clickType(shopids[index])">
							{{ item }}
						</div>
					</div>
				</div>
				<div class="list">
					<div class="item" v-for="(item, index) in shops" :key="index" @click="handleGoActivity(item.id)">
						<div class="item-t">
							<div class="info">
								<div class="title ellipsis1">{{ item.name }}</div>
								<div class="font">联系电话：{{ item.tel }}</div>
								<div class="font">联系人：{{ item.person }}</div>
								<div class="km">
									<img src="../assets/img/icon/footerIcon/tab-nearby-current-blue.png" class="icon"></img>
									距离 {{ item.dis_show }}
								</div>
							</div>
							<div class="imgbox">
								<img :src="item.logo" class="img" mode="aspectFill"></img>
								<text class="tag">联盟商家</text>
							</div>
						</div>
						<div class="item-b">
							<div class="txt">联系我时，请说是在“收到乐”平台看到的 谢谢!</div>
							<div class="anniu">联系我</div>
						</div>
					</div>
				</div>
			</div>
			
			<!-- 限时抢购 -->
			<div class="modal idx-store" v-if="dataList.home_tejia_img.img_url!=null">
				<div class="modal_top">
					<div class="title_box">
						<div class="title_box_l">
							<img src="../assets/img/idx_i16_blue.png" class="icon"></img>
							<div class="title">
								<div class="gl">特价</div>
								商品
							</div>
						</div>
						<div class="title_box_r" @click="goTj()">
							查看全部
							<img src="../assets/img/idx_arr.png" class="arr"></img>
						</div>
					</div>
				</div>
				<div class="list">
					<img @click="goTj()" :src="dataList.home_tejia_img.img_url" class="my-ad"></img>
				</div>
			</div>
			
			<div class="modal idx-vip-store">
				<div class="modal_top">
					<div class="title_box">
						<div class="title_box_l">
							<img src="../assets/img/idx_i14_blue.png" class="icon"></img>
							<div class="title">
								<div class="gl">会员</div>
								红包商城
							</div>
						</div>
						<div class="title_box_r" @click="handleGoList">
							查看全部
							<img src="../assets/img/idx_arr.png" class="arr"></img>
						</div>
					</div>
					<div class="recommend_box">
						<div class="box_l" @click="changeGoods(0)">
							<img src="../assets/img/idx_tit.png" class="icon"></img>
							<div v-if="currentIndex === 0" class="btn">会员专享</div>
							<div v-else class="my-title">会员专享</div>
						</div>
						<div class="box_r">
							<div class="box_r_b" v-for="(item, index) in datas.cates" :key="index"
								@click="changeGoods(item.id)">
								<div class="name">{{ item.name }}</div>
								<div v-if="currentIndex === item.id" class="my-active">{{ item.str }}</div>
								<div v-else class="tit">{{ item.str }}</div>
							</div>
						</div>
					</div>
				</div>
				<div class="modal_wrap">
					<div class="brand_box" @click="goBrands()">
						<div class="brand_box_t">
							<div class="title">品牌集锦</div>
							<img src="../assets/img/idx_arr2.png" class="arr" mode="aspectFill"></img>
						</div>
						<div class="slider_box">
							<div class="li" v-for="(item, index) in datas.brands" :key="index">
								<img :src="item.logo" class="img" mode="aspectFill"></img>
								<div class="title">{{ item.name }}</div>
							</div>
						</div>
					</div>
					<div class="list">
						<div class="item" v-for="(item, index) in goods" :key="index"
							@click="handleGoGoodsInfo(item.id)">
							<img :src="item.logo" class="img" mode="aspectFill"></img>
							<div class="info">
								<div class="name ellipsis">{{ item.name }}</div>
								<div class="info_b">
									<div class="price">
										<text class="dw">￥</text>
										{{ item.hb_num }}
									</div>
									<div class="btn">去兑换</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="my-more" @click="handleGoList()">点击查看更多</div>
			<!-- <div class="my-kefu">
				<p>客服电话 ：<a href="tel:4000567831">4000567831</a></p>
				<p>微信(电话) ：<a href="tel:13522618284">13522618284</a></p>
				<p>联系我时，请说是在“收到乐”平台看到的 谢谢!</p>
				<p><a href="https://beian.miit.gov.cn/">京ICP备19056392号@copy right</a></p>
			</div> -->
			<FooterKefu/>
		</div>
		<div style="clear: both;"></div>
		<footer>
			<TheFooterBar :active="1" />
		</footer>
	</div>
</template>

<script>
	import TheFooterBar from '../components/base/TheFooterBar';
	import FooterKefu from '../components/base/FooterKefu';
	import {
		getBannersListService,
		getNewGoodsService,
		getRecommendGoodsService,
		getHomeService
	} from '../service/goodsService';
	import {
		getConsultationServive,
		getConsultationDetailsServive,
		getVisitsnumService
	} from '../service/untilService';
	import {
		getHomeShops,
		getHomeShopsCate
	} from '../service/basicService';
	import {
		Toast,
		Dialog,
		Picker,
		Popup
	} from 'vant';
	import Cookies from 'js-cookie'; // 缓存
	import {
		getUrlParamsTools
	} from '../util/tools';
	import {
		doUserShareService
	} from '../service/basicService';
	import {
		mapState
	} from 'vuex';
	import vue from 'vue';
	import {
		wecharShare
	} from '../util/weChat.js';
	import wx from 'weixin-js-sdk';
	vue.use(Picker);
	vue.use(Popup);
	export default {
		data() {
			return {
				showBg: false,
				searchKey: '', //搜索关键字
				// swipeList:[],//轮播图列表
				imgBack: null,
				// iconList:[],//图标列表
				// advertisement:'',//咨询信息
				// newGoods:[],//新品推荐列表
				recommendGoodsList: [], //推荐商品
				dataList: {}, //首页信息
				datas: {},
				goods: {},
				currentIndex: 0,
				bac: 0,
				shops: {},
				// visitsNum:0,//访问量
				// loading: false,
				// finished: false,
				// offset:{
				//     page:1,
				//     limit:10,
				// },
				myLocation: {
					address: '',
					// address:"北京市",
					// latitude:33.05614,
					latitude: 0,
					// longitude:112.94793,
					longitude: 0
				},
				showPicker: false,
				catevalue: '',
				cateindex: 0,
				shopcates: {},
				shopids: [],
				ids: [],
				typeCur: 0,
				names: []
			};
		},
		mounted() {
			//获取首页数据
			this.getHome();
			wecharShare(location.href.split('#')[0], '');
			window.addEventListener('scroll', this.onPageScroll, true); // 监听（绑定）滚轮滚动事件
		},
		created() {
			this.shareOpenId = getUrlParamsTools('openid');
			if (this.shareOpenId != null) {
				this.doUserShare(this.shareOpenId);
			}
		},
		activated() {
			console.log('页面显示');
			console.log('home-user-id', this.userId);
			const is_xy = Cookies.get('is_xy');
			// 用户同意协议
			if (!is_xy) {
				Dialog.confirm({
						confirmButtonColor: '#00BFFF',
						title: '服务协议和隐私政策',
						confirmButtonText: '同意',
						cancelButtonText: '暂不使用',
						closeOnClickOverlay: true,
						message: '请你务必审慎阅读、充分理解“服务协议”和“隐私政策”各条款，包括但不限于：为了向你提供良好的用户体验，我们需要收集你的设备信息，操作日志等个人信息。你可阅读“<a href="https://www.shoudaole.cn/dist/#/fuwuxieyi">《服务协议》”</a>和“<a target="_blank" href="https://www.shoudaole.cn/dist/#/yinsizhengce">《隐私政策》</a>”了解详细信息。如你同意，请点击“同意”开始接受我们的服务。'
					})
					.then(() => {
						Cookies.set('is_xy', 1);
					})
					.catch(() => {
						// Cookies.set('is_xy', 0);
					});
			}
		},
		deactivated() {
			console.log('页面隐藏');
			Dialog.close();
		},
		methods: {
			onPageScroll(e) {
				var top = Math.floor(document.body.scrollTop || document.documentElement.scrollTop || window.pageYOffset)
				if (top > 45) {
					this.showBg = true;
				} else {
					this.showBg = false;
				}
			},
			goBrands() {
				this.$router.push({
					name: 'brands'
				});
			},
			goShops() {
				this.$router.push({
					name: 'nearbyShop'
				});
			},
			onConfirm(value, index) {
				console.log('catechange', index);
				//切换账号
				this.showPicker = false;
				this.catevalue = value;
				this.cateindex = index;
				this.getHomeShop();
			},
			// 随机颜色
			randColor() {
				let R = Math.floor(Math.random() * 255);
				let G = Math.floor(Math.random() * 255);
				let B = Math.floor(Math.random() * 255);
				return {
					color: 'rgb(' + R + ',' + G + ',' + B + ')'
				};
			},
			getMyLocation() {
				console.log('run:getMyLocation');
				var geolocation = new qq.maps.Geolocation();
				var options = {
					timeout: 9000
				};
				geolocation.getLocation(this.showPosition, this.showErr, options); //或者用getLocation精确度比较高
			},
			showPosition(position) {
				console.log(position);
				this.index = 1;
				this.myLocation.latitude = position.lat;
				this.myLocation.longitude = position.lng;
				var str = position.addr;
				str = str.slice(0, 15) + '...';
				this.myLocation.address = str;
				this.getHomeShopsCates(1);
				this.show = true;
				this.showLoading = false;
				// this.setMap();
			},
			showErr() {
				console.log('定位失败');
				this.getMyLocation(); //定位失败再请求定位，测试使用
			},
			// 39.85856,116.28616
			getHomeShop() {
				// let cateid = this.ids[this.cateindex];
				let cateid = this.typeCur;
				getHomeShops(this.myLocation.latitude, this.myLocation.longitude, cateid)
					.then(res => {
						console.log('homeshops', res);
						this.shops = res.datas;
					})
					.catch(err => {
						console.log(err);
					});
			},
			getHomeShopsCates(e) {
				var that = this;
				getHomeShopsCate(e)
					.then(res => {
						that.shopcates = res.datas.names;
						that.shopids = res.datas.ids;
						console.log('getHomeShopsCates', res);
						let cates = res.datas;
						this.ids = cates.ids;
						this.names = cates.names;
						this.catevalue = cates.names[0];
						this.cateindex = cates.ids[0];
						this.getHomeShop();
					})
					.catch(err => {
						console.log(err);
					});
			},
			clickType(e) {
				this.typeCur = e;
				var that = this;
				that.getHomeShopsCates(that.typeCur);
			},
			changeGoods(id) {
				this.currentIndex = id;
				if (id == 0) {
					this.goods = this.dataList.recommend;
				} else {
					this.goods = this.dataList.cates_goods[id];
				}
			},
			doUserShare(shareOpenId) {
				// 记录分享人openid
				doUserShareService(shareOpenId, this.openId)
					.then(res => {
						if (res.status === 1) {
							console.log('已记录分享人');
						} else {
							Toast(res.msg);
						}
					})
					.catch(err => {
						console.log(err);
					});
			},
			handleGoNows(id) {
				console.log(this.dataList.notice.id);

				this.$router.push({
					name: 'nows',
					params: {
						id: this.dataList.notice.id
					}
				});
			},
			handleGoActivity(shopId) {
				this.$router.push({
					name: 'shopActivityDetails',
					params: {
						shopId
					}
				});
			},
			//搜索
			handleSearch() {
				this.$router.push({
					name: 'search'
				});
			},
			goTj() {
				this.$router.push({
					name: 'offer',
					params: {
						typeId: 0
					}
				});
			},
			goXs() {
				this.$router.push({
					name: 'xs/goods',
					params: {
						typeId: 0,
						searchKey: '-1'
					}
				});
			},
			//跳转链接
			handleGoIcon(item) {
				console.log(item);
				if (item.jump_type == 1) {
					window.location.href = item.param;
				} else {
					if (item.param.wechat == 'goodsMuster') {
						this.$router.push({
							name: 'goodsMuster',
							params: {
								typeId: 0,
								searchKey: '-1'
							}
						});
					} else if (item.param.wechat == 'nows') {
						const id = item.param.ios;
						this.$router.push({
							name: 'nows',
							params: {
								id: id
							}
						});
					} else if (item.param.wechat == 'offer') {
						this.$router.push({
							name: 'offer',
							params: {
								typeId: 0
							}
						});
					} else {
						this.$router.push({
							name: item.param.wechat
						});
					}
					// else if (item.param.wechat == 'luck') {
					// 	if (this.userId === null) {
					// 		Toast('请您先登录');
					// 		this.$router.push({
					// 			name: 'userLogin'
					// 		});
					// 	} else {
					// 		window.location.href = 'https://www.shoudaole.cn/luck/?uid=' + this.userId +'&timestamp='+ new Date().getTime();
					// 	}
					// }
				}
			},
			// banner跳转
			bannerJump(item) {
				if (item.jump_type == 1) {
					window.location.href = item.param;
				} else {
					if (item.param.wechat == 'goodsMuster') {
						this.$router.push({
							name: 'goodsMuster',
							params: {
								typeId: 0,
								searchKey: '-1'
							}
						});
					} else if (item.param.wechat == 'nows') {
						const id = item.param.ios;
						this.$router.push({
							name: 'nows',
							params: {
								id: id
							}
						});
					} else {
						this.$router.push({
							name: item.param.wechat
						});
					}
				}
			},

			//首页轮播图模糊效果
			// handleChangeSwipe(index){
			//     console.log(this.dataList.bannerslist[index])
			//     this.imgBack = this.dataList.bannerslist[index].img_url;

			// },

			//查询咨询详情
			handleGoConsultation() {
				this.$router.push({
					name: 'baseConsultation',
					params: {
						id: this.advertisement.id
					}
				});
			},

			//获取新品商品信息
			getNewGoods() {
				getNewGoodsService()
					.then(res => {
						if (res.status === 1) {
							this.newGoods = res.datas;
						} else {
							Toast(res.msg);
						}
					})
					.catch(err => {
						console.log(err);
					});
			},

			//查询所有商品
			handleGoList() {
				this.$router.push({
					name: 'goodsMuster',
					params: {
						typeId: 0,
						searchKey: '-1'
					}
				});
			},
			handleGoNearByShop() {
				this.$router.push({
					name: 'nearbyShop'
				});
			},
			//跳转页面(无参数)
			handleGoNext(param) {
				console.log(param);
				this.$router.push({
					name: param
				});
			},
			//跳转商品详情
			handleGoGoodsInfo(goodsId) {
				this.$router.push({
					name: 'goodsDetails',
					params: {
						goodsId
					}
				});
			},

			//获取首页信息
			getHome() {
				var that = this;
				getHomeService(1)
					.then(res => {
						if (res.status === 1) {
							this.dataList = res.datas;
							this.datas = res.datas;
							this.goods = this.dataList.recommend;
							// this.handleChangeSwipe(0);
							setTimeout(function() {
								that.getMyLocation();
							}, 500);
						} else {
							Toast(res.msg);
						}
					})
					.catch(err => {
						console.log(err);
					});
			},
			// 跳转到直播小程序
			goLive() {
				var that = this;
				var ua = a.userAgent.toLowerCase();
				if (ua.match(/MicroMessenger/i) == 'micromessenger') {
					wx.miniProgram.getEnv(res => {
						if (res.miniprogram) {
							Toast('在小程序');
							// 跳转到小程序支付
							let payData = {
								test: 1
							};
							let payDataStr = JSON.stringify(payData); //因为要吧参数传递给小程序，所以这里需要转为字符串
							const url = `/pages/live/index?test=${payDataStr}`;
							wx.miniProgram.navigateTo({
								url: url
							});
							that.isp = 1;
							return false;
						} else {
							console.log('在公众号');
							that.isp = 2;
							return false;
						}
					});
				} else {
					//都不在
					Toast('请在微信环境打开');
					that.isp = 1;
					return false;
				}
			}
		},
		components: {
			// BaseFooterBar,
			TheFooterBar,
			FooterKefu
		},
		computed: {
			...mapState({
				openId: state => state.userInfo.openId,
				userId: state => state.userInfo.userId
			})
		}
	};
</script>

<style lang="scss" scoped>
	.page {
		background-color: #faf8f8;
		padding-bottom: 60px;
	}

	.pub_nav {
		font-size: 12px;
		color: #fff;
		position: fixed;
		top: 0;
		left: 0;
		right: 0;
		z-index: 99;
		background: -webkit-gradient(linear, left bottom, right top, from(#A9F0F8), to(#00BFFF));
		// background: linear-gradient(to top right, #A9F0F8, #00BFFF) !important;
		font-size: 17px;
		background: none;
		box-sizing: border-box;
		height: 45px !important;
		padding-top: 0px;
		box-sizing: border-box;
		// 
	}

	.nav_bg {
		background: linear-gradient(to top right, #00BFFF, #8EFBFA) !important;
		z-index: 999;
	}

	.pub_nav .nav_box {
		display: flex;
		align-items: center;
		position: absolute;
		justify-content: flex-start;
		height: 45px !important;
		right: 10px;
		left: 10px;
	}

	.pub_nav .search_box {
		background: #fff;
		border-radius: 10px;
		height: 33px;
		display: flex;
		align-items: auto;
		padding: 2px;
		align-items: center;
		box-sizing: border-box;
		justify-content: flex-start;
		margin-left: 12px;
		flex: 1;
		font-size: 12px;
	}

	.search_box input {
		width: 84%;
	}

	.search_box .icon {
		height: 100%;
		width: 16%;
	}

	.placeColor {
		padding-left: 10px;
	}

	.top_img {
		height: 240px;
		position: absolute;
		top: 0;
		width: 100%;
	}

	.idx_main {
		padding-top: 45px;
	}

	.idx_main_top {
		background: #fff;
		border-radius: 0 0 25px 25px;
		padding-bottom: 15px;
		overflow: hidden;
	}

	.swier-bg-box {
		display: block;
		// position: relative;
		background-repeat: no-repeat;
		margin-top: 10px;
		background-size: 100%;
		margin-bottom: 10px;
		overflow: hidden;
		width: 100%;
	}

	.idx_main .swiper_box {
		padding: 10px;
	}

	.idx_main .swiper_box .img {
		display: block;
		width: 100%;
		height: 100%;
		border-radius: 10px;
	}

	.idx_main .swiper_box .hot_box {
		display: flex;
		align-items: center;
		font-size: 12px;
		color: #fff;
		flex-wrap: wrap;
		position: relative;
	}

	.idx_main .swiper_box .hot_box .tit {
		margin-right: 10px;
	}

	.idx_main .swiper_box .hot_box .hot {
		padding: 0 7px;
		line-height: 20px;
		border-radius: 25px;
		background: rgba(255, 255, 255, .16);
		margin: 2.5px 5px;
	}

	.idx_main .swiper_box swiper {
		margin-top: 17.5px;
		padding-bottom: 15px;
		height: 162.5px;
	}

	.idx_main .swiper_box .swiper-item {
		height: 162.5px;
		border-radius: 10px;
		width: 100%;
	}

	.idx_main .swiper_box .img {
		height: 162.5px;
		border-radius: 10px;
	}

	.idx_main .menus {
		display: flex;
		align-items: center;
		flex-wrap: wrap;
		background: #fff;
		border: 0 0 25px 25px;
	}

	.idx_main .menus .menu {
		text-align: center;
		width: 20%;
		margin-bottom: 10px;
	}

	.idx_main .menus .menu .icon {
		width: 45px;
		height: 45px;
	}

	.idx_main .menus .menu .tit {
		font-size: 11px;
		color: #666666;
		margin-top: 5px;
	}

	.idx_main .active_box {
		padding: 15px;
	}

	.idx_main .active_box_c {
		background: #fff;
		border-radius: 7.5px;
	}

	.idx_main .active_box_c .li {
		padding: 0 15px;
		height: 40px;
		display: flex;
		align-items: center;
	}

	.idx_main .active_box_c .li .icon {
		width: 17px;
		height: 16px;
		margin-right: 12.5px;
	}

	.idx_main .active_box_c .li .title {
		font-size: 12px;
		color: #033333;
		flex: 1;
	}

	.idx_main .active_box_c .li .arr {
		width: 6px;
		height: 10px;
	}

	.modal_top {
		background-image: linear-gradient(to bottom, #faedf0, #faf8f8);
	}

	.modal_top .title_box {
		display: flex;
		align-items: center;
		padding: 15px;
	}

	.modal_top .title_box_l {
		display: flex;
		align-items: center;
		flex: 1;
	}

	.modal_top .title_box_l .icon {
		width: 20px;
		height: 20px;
		margin-right: 5px;
	}

	.modal_top .title_box_l .title {
		font-size: 18px;
		color: #333333;
		font-weight: bold;
		display: flex;
		align-items: center;
	}

	.modal_top .title_box_l .title .gl {
		//color: #ff605f;
		color: #00BFFF;
	}

	.modal_top .title_box_r {
		display: flex;
		align-items: center;
		font-size: 12px;
		color: #999999;
	}

	.modal_top .title_box_r .arr {
		width: 5px;
		height: 10px;
		margin-left: 7.5px;
	}

	.modal_top .types {
		overflow-x: scroll;
		white-space: nowrap;
		padding-left: 15px;
	}

	.modal_top .types::-webkit-scrollbar {
		display: none;
	}

	.modal_top .types .type {
		display: inline-block;
		border-radius: 25px;
		background: #fff;
		padding: 0 10px;
		line-height: 25px;
		margin-right: 10px;
		font-size: 12px;
		color: #333333;
	}

	.modal_top .types .type.cur {
		background: #fbe1e7;
		color: #00BFFF;
	}

	.idx-store .list {
		padding: 0 15px;
		margin-top: 10px;
	}

	.idx-store .list .item {
		padding: 0 10px;
		border-radius: 8px;
		margin-bottom: 10px;
		background: #fff;
	}

	.idx-store .list .item-t {
		padding: 10px 0;
		display: flex;
		justify-content: space-between;
	}

	.idx-store .list .info {
		padding: 0 7.5px;
		flex: 1;
		overflow: hidden;
	}

	.idx-store .list .title {
		font-size: 17px;
		color: #333333;
		font-weight: bold;
		margin-bottom: 5px;
	}

	.idx-store .list .font {
		font-size: 12px;
		color: #999999;
		line-height: 18px;
	}

	.idx-store .list .km {
		font-size: 12px;
		color: #00BFFF;
		margin-top: 12.5px;
		display: flex;
		align-items: center;
	}

	.idx-store .list .km .icon {
		width: 11.5px;
		height: 14px;
		margin-right: 5px;
		display: inline-block;
	}

	.idx-store .list .imgbox {
		position: relative;
		width: 105px;
		border-radius: 3px;
		overflow: hidden;
	}

	.idx-store .list .img {
		width: 100%;
		height: 105px;
	}

	.idx-store .list .tag {
		position: absolute;
		left: 0;
		top: 0;
		border-radius: 3px 0 10px 0;
		font-size: 12px;
		color: #fff;
		min-width: 62.5px;
		text-align: center;
		line-height: 20px;
		padding: 0 5px;
		background: linear-gradient(to right, #ffd12a, #00BFFF);
	}

	.idx-store .list .item-b {
		padding: 12.5px 0;
		border-top: 1px solid #efefef;
		display: flex;
		justify-content: space-between;
		align-items: center;
	}

	.idx-store .list .txt {
		font-size: 12px;
		color: #999999;
		line-height: 18px;
		width: 232.5px;
		padding: 0 7.5px;
	}

	.idx-store .list .anniu {
		font-size: 14px;
		color: #fff;
		width: 75px;
		line-height: 30px;
		background: linear-gradient(to top right, #00BFFF, #A9F0F8);
		border-radius: 15px;
		text-align: center;
	}

	.idx-vip-store .modal_top .gl {
		color: #ff5b1b;
	}

	.idx-vip-store .recommend_box {
		display: flex;
		align-items: center;
		padding-left: 15px;
	}

	.idx-vip-store .recommend_box .box_l {
		margin-right: 20px;
		width: 62.5px;
		text-align: center;
	}

	.idx-vip-store .recommend_box .box_l .icon {
		width: 50px;
		height: 12.5px;
	}

	.idx-vip-store .recommend_box .box_l .btn {
		width: 50px;
		height: 12.5px;
		width: 60px;
		height: 21.5px;
		line-height: 21.5px;
		border-radius: 25px;
		text-align: center;
		background: linear-gradient(to top right, #A9F0F8, #00BFFF);
		margin-top: 5px;
		font-size: 11px;
		color: #fff;
	}

	.idx-vip-store .recommend_box .box_r {
		display: flex;
		align-items: center;
		flex: 1;
	}

	.idx-vip-store .recommend_box .box_r_b {
		flex: 1;
		text-align: center;
		border-left: 1px solid #e2e2e2;
	}

	.idx-vip-store .recommend_box .box_r_b .name {
		font-size: 13px;
		color: #333333;
	}

	.idx-vip-store .recommend_box .box_r_b .tit {
		font-size: 12px;
		color: #999999;
		margin-top: 7.5px;
	}

	.idx-vip-store .modal_wrap {
		padding: 15px;
	}

	.idx-vip-store .brand_box {
		border-radius: 10px;
		padding: 5px;
		background: linear-gradient(to top, #A9F0F8, #00BFFF);
	}

	.idx-vip-store .brand_box_t {
		display: flex;
		align-items: center;
		justify-content: space-between;
		height: 35px;
		padding: 0 7.5px;
	}

	.idx-vip-store .brand_box_t .title {
		font-size: 16px;
		color: #fff;
	}

	.idx-vip-store .brand_box_t .arr {
		width: 6px;
		height: 10px;
	}

	.idx-vip-store .slider_box {
		overflow-x: scroll;
		white-space: nowrap;
		background: #fff;
		border-radius: 7.5px;
		margin-top: 5px;
	}

	.idx-vip-store .slider_box::-webkit-scrollbar {
		display: none;
	}

	.idx-vip-store .slider_box .li {
		display: inline-block;
		width: 95px;
		text-align: center;
		padding: 10px 0;
		border-right: 1px solid #ededed;
	}

	.idx-vip-store .slider_box .li .img {
		width: 75px;
		height: 60px;
		display: inline-block;
	}

	.idx-vip-store .slider_box .li .title {
		margin-top: 5px;
		font-size: 12px;
		color: #333333;
	}

	.idx-vip-store .list {
		margin-top: 15px;
		display: flex;
		flex-wrap: wrap;
	}

	.idx-vip-store .list .item {
		background: #fff;
		border-radius: 7px;
		overflow: hidden;
		margin-bottom: 10px;
		width: 166.5px;
	}

	.idx-vip-store .list .item .img {
		height: 165px;
	}

	.idx-vip-store .list .item:nth-child(2n) {
		margin-left: 10px;
	}

	.idx-vip-store .list .info {
		padding: 7.5px;
		box-sizing: border-box;
	}

	.idx-vip-store .list .info .name {
		-webkit-line-clamp: 2;
		font-size: 13px;
		color: #333333;
		line-height: 19px;
		height: 35px;
	}

	.idx-vip-store .list .info_b {
		display: flex;
		align-items: center;
		justify-content: space-between;
		margin-top: 12.5px;
	}

	.idx-vip-store .list .info_b .price {
		font-size: 18px;
		color: #00BFFF;
		font-weight: bold;
		display: flex;
		align-items: flex-end;
	}

	.idx-vip-store .list .info_b .price .dw {
		font-size: 13px;
		font-weight: initial;
	}

	.idx-vip-store .list .info_b .btn {
		background: linear-gradient(to top right, #A9F0F8, #00BFFF);
		border-radius: 25px;
		width: 62.5px;
		line-height: 20px;
		height: 20px;
		text-align: center;
		font-size: 11px;
		color: #fff;
	}

	.my-more {
		width: 100%;
		text-align: center;
		padding-bottom: 60rpx;
		font-size: 26rpx;
		color: #999999;
		padding-bottom: 10px;
		border-bottom: 1px solid #efefef;
	}

	.my-kefu {
		margin-top: 10px;
		width: 100%;
		text-align: center;
		padding-bottom: 60rpx;
		font-size: 26rpx;
		color: #999999;
	}

	.my-kefu p {
		height: 24px;
		line-height: 24px;
	}

	.my-active {
		width: 1.5625rem;
		height: 0.39063rem;
		width: 1.875rem;
		height: 0.67188rem;
		line-height: 0.67188rem;
		border-radius: 0.78125rem;
		text-align: center;
		background: -webkit-gradient(linear, left bottom, right top, from(#A9F0F8), to(#00BFFF));
		background: linear-gradient(to top right, #A9F0F8, #00BFFF);
		margin-top: 0.15625rem;
		font-size: 0.34375rem;
		margin-left: 5px;
		color: #fff;
	}

	.my-title {
		font-size: 22rpx;
	}
	
	.my-ad{
		width: 100%;
		height: 140px;
		margin-bottom: 5px;
		border-radius: 10px;
	}

	// /deep/ .wx-swiper-dots.wx-swiper-dots-horizontal{
	// 	position: absolute;bottom: 0;z-index: 1000;background: #fed7d5;border-radius: 25px;
	// }
	// /deep/ .wx-swiper-dot.wx-swiper-dot{
	// 	width: 10px;
	// 	height: 4px;
	// 	border-radius: 25px;
	// 	background: #fed7d5;
	// 	opacity: 0.5;
	// 	margin-right: 2px !important;
	// }
	// /deep/ .wx-swiper-dot.wx-swiper-dot:last-child{margin-right: 0 !important;}
	// /deep/ .wx-swiper-dot.wx-swiper-dot-active{
	// 	width: 10px;
	// 	height: 4px;
	// 	border-radius: 25px;
	// 	background:#00BFFF;
	// 	opacity: 1;
	// }
	/deep/uni-swiper .uni-swiper-dots-horizontal {
		position: absolute;
		bottom: 0 !important;
		z-index: 1000;
		background: #fed7d5;
		border-radius: 25px;
	}

	/deep/ .uni-swiper-dot.uni-swiper-dot {
		width: 10px;
		height: 4px;
		border-radius: 25px;
		background: #fed7d5;
		opacity: 0.5;
		margin-right: 2px !important;
	}

	/deep/ .uni-swiper-dot.uni-swiper-dot:last-child {
		margin-right: 0 !important;
	}

	/deep/ .uni-swiper-dot-active {
		width: 10px;
		height: 4px;
		border-radius: 25px;
		background: #00BFFF !important;
		opacity: 1 !important;
	}
</style>
